/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessStatsResponseDto } from '../../models/access-stats-response-dto';

export interface DocumentAccessLogControllerGetAccessStats$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Start time filter (Unix timestamp)
 */
  startTime?: number;

/**
 * End time filter (Unix timestamp)
 */
  endTime?: number;
}

export function documentAccessLogControllerGetAccessStats(http: HttpClient, rootUrl: string, params: DocumentAccessLogControllerGetAccessStats$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessStatsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAccessLogControllerGetAccessStats.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccessStatsResponseDto>;
    })
  );
}

documentAccessLogControllerGetAccessStats.PATH = '/thalea-documents/access-logs/{tenant}/stats';
